// Figma "Banner" (App-wide modals & banners · web): a page-level note at the
// top of main, inset like the page. Accent: a coach viewing an athlete.
// Warning: the coach is paused. Neutral: the trial. One small action on the
// right (Secondary on Accent, Primary otherwise).
import React from 'react';
import { cn } from '../../lib/utils';

const TONE = {
  accent: 'border-accent-tint-border bg-accent-tint',
  warning: 'border-zone-threshold bg-bg-surface',
  neutral: 'border-border-default bg-bg-surface',
};

/** The banner's place: the same inset and width as the page under it. */
export const BANNER_INSET = 'mx-auto max-w-7xl px-4 pt-4 md:px-6 md:pt-6 lg:px-8 lg:pt-8';

export function PageBanner({ tone = 'neutral', icon = null, action = null, className, children, ...props }) {
  return (
    <div className={cn('flex flex-wrap items-center gap-3 rounded-[14px] border px-4 py-3 sm:flex-nowrap', TONE[tone], className)} {...props}>
      <p className="m-0 flex min-w-0 flex-1 items-center gap-2 type-body-small text-text-primary">
        {icon}
        <span className="min-w-0">{children}</span>
      </p>
      {action}
    </div>
  );
}
